module.exports = __webpack_public_path__ + "img/level_2.3b08f96d.png";